<template>
  <div>

    <tabs :tabs="tabs" :setActiveTab="activeTab" @onClickTab="changeTab"></tabs>

    <div class="border p-3 " v-if="tabDados">

      <div class="row flex-column align-items-center justify-content-center">
        <span class="lbl-deal-title  spacing-px w-100">Logotipo</span>
        <div class="d-flex flex-column align-items-center">
          <div class="">
            <div class="" style="padding: 10px;" data-toggle="tooltip" data-placement="bottom">
              <img v-if="image" :src="image" class="mx-auto img-thumbnail" alt="Logotipo"
                style="max-width: 130px; max-height: 130px; cursor: pointer;" @click="handleClickLogotipo()">
              <!-- <span v-if="image" class="data-list" style="cursor: pointer" @click="apiDeleteImage"><small><i class="fa fa-trash" aria-hidden="true"></i> Remover Imagem </small></span> -->
              <i v-if="!image" class="img-thumbnail fa fa-camera" style="font-size: 72px; color: silver; cursor: pointer"
                @click="handleClickLogotipo()"></i>
            </div>
            <div class="row">
              <input v-show="false" id="anexo" type="file" ref="logotipo" accept="image/*"
                @change="handleUploadLogotipo($event)">
            </div>
          </div>
        </div>
        <div class="d-flex w-100" style="max-width: 60%">
          <form-field v-model="filial.site" type="text" col="6" :metadata="metadata.filial.site" name="site"
            :v-errors="errors" v-validate="metadata.filial.site.validator" />
          <form-field v-model="filial.email" type="email" col="6" :metadata="metadata.filial.email" name="email"
            :v-errors="errors" v-validate="metadata.filial.email.validator"></form-field>
        </div>
      </div>
      <hr>
      <div class="row flex-column w-100 spacing-px">
        <span class="lbl-deal-title">Endereço</span>
        <div class="row">
          <form-field v-model="filial.cep" type="cep" col="2" :metadata="metadata.filial.cep"
            @update="updateCep"></form-field>
          <form-field v-model="filial.ende" type="text" col="6" :metadata="metadata.filial.ende" name="ende"
            :v-errors="errors" v-validate="metadata.filial.ende.validator"></form-field>

        </div>
        <div class="row">
          <form-field v-model="filial.bairro" type="text" col="4" :metadata="metadata.filial.bairro" name="bairro"
            :v-errors="errors" v-validate="metadata.filial.bairro.validator"></form-field>
          <form-field v-model="filial.endenr" type="text" col="2" :metadata="metadata.filial.endenr" name="endenr"
            :v-errors="errors" v-validate="metadata.filial.endenr.validator"></form-field>
          <form-field v-model="filial.endecomp" type="text" col="4" :metadata="metadata.filial.endecomp" name="endecomp"
            :v-errors="errors" v-validate="metadata.filial.endecomp.validator"></form-field>
        </div>
        <div class="row">
          <form-field v-model="filial.uf" type="select2" col="4" :metadata="metadata.filial.uf" name="uf"
            :v-errors="errors" v-validate="metadata.filial.uf.validator"></form-field>
          <form-field v-model="filial.codmun" type="select2" col="4" :metadata="metadata.filial.codmun" name="codmun"
            :v-errors="errors" v-validate="metadata.filial.codmun.validator"
            :select2="{ entity: 'mun/uf/' + filial.uf, minlength: 2 }"></form-field>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-12">
          <v-button label="Salvar" :success="true" @click="handleSaveFilial"></v-button>
        </div>
      </div>
    </div>


    <!-- CONFIGURACOES -->

    <div class="border p-3" v-if="tabConfig">
      <span class="lbl-deal-title mb-3">Tabela de Preços Padrão</span>
      <!-- <label-title class="mb-2" title="Tabela de Preços Padrão" icon=""></label-title> -->
      <div class="row">
        <div class="col-12">
          <span class="lbl-edit">
            Selecione uma tabela padrão para os produtos da loja
          </span>
        </div>
        <form-field v-model="configloja.codtabpre" type="select2" col="4" :select2="{ entity: 'tabpre', minlength: 0 }"
          name="codtabpre" :v-errors="errors" v-validate="metadata.configloja.codtabpre.validator"></form-field>
      </div>
      <hr>
      <span class="lbl-deal-title mt-4">Usuário Padrão</span>
      <!-- <label-title class="mt-3" title="Usuário" icon=""></label-title> -->
      <div class="row">
        <div class="col-12">
          <span class="lbl-edit">
            Selecione um usuário para recebimento de e-mails dos pedidos
          </span>
        </div>
        <form-field v-model="configloja.codusuario" type="select2" col="4"
          :select2="{ entity: 'usuario', minlength: 0 }"></form-field>
      </div>
      <hr>
      <span class="lbl-deal-title mt-4">TIPO DE LOJA B2B</span>
      <div class="row">
        <div class="col-12">
          <input-checkbox label="Vendas realizadas de empresa para empresa"
            v-model="configloja.b2b" :value-checked="true" :value-unchecked="false"></input-checkbox>
        </div>
        <div class="col-12" v-if="configloja.b2b">
          <span class="lbl-edit">
            É necessário realizar liberação de login no cadastro de cliente
          </span>
        </div>
      </div>

      <hr>
      <span class="lbl-deal-title mt-4">Controle de estoque</span>
      <div class="row">
        <div class="col-12">
          <input-checkbox label="Controlar estoque na loja e bloquear venda de produtos sem estoque"
            v-model="configloja.controlaestoque" :value-checked="true" :value-unchecked="false"></input-checkbox>
        </div>
      </div>
      <hr>
      <span class="lbl-deal-title mt-4">Tipo de Pedido</span>
      <div class="row">
        <div class="col-12">
          <div class="custom-control custom-radio">
            <input type="radio" id="customRadio1" class="custom-control-input" value="P" v-model="configloja.tppedv">
            <label class="custom-control-label data-list" for="customRadio1">Pedido de Venda</label>
          </div>
        </div>
        <div class="col-12">
          <div class="custom-control custom-radio">
            <input type="radio" id="customRadio2" class="custom-control-input" value="O" v-model="configloja.tppedv">
            <label class="custom-control-label data-list" for="customRadio2">Orçamento</label>
          </div>
        </div>
      </div>
      <hr>
      <span class="lbl-deal-title mt-4">Valor mínimo Pedido</span>
      <div class="row">
        <form-field v-model="configloja.valor_minimo_pedido" type="value" :precision="2" col="3" label="Valor mínimo" name="valor_minimo_pedido" :v-errors="errors"
          v-validate="{}"></form-field>
       </div>

      <hr>
      <span class="lbl-deal-title mt-4">Telefones para contato</span>
      <!-- <label-title class="mt-3" title="Telefones para contato" icon=""></label-title> -->
      <div class="row">
        <form-field v-model="configloja.fone" type="fone" col="3" label="Telefone" name="fone" :v-errors="errors"
          v-validate="{ max: 30 }"></form-field>
      </div>
      <div class="row">
        <form-field v-model="configloja.whatsapp" type="fone" col="3" label="Whatsapp para contato" name="whatsapp"
          :v-errors="errors" v-validate="{ max: 30 }"></form-field>
      </div>
      <div class="row">
        <form-field v-model="configloja.instagram" type="text" col="4" label="Instagram da sua Loja" name="whatsapp"
          :v-errors="errors" v-validate="{ max: 30 }" preaddon="www.instagram.com/"></form-field>
      </div>
      <div class="row">
        <form-field v-model="configloja.facebook" type="text" col="4" label="Facebook da sua Loja" name="whatsapp"
          :v-errors="errors" v-validate="{ max: 30 }" preaddon="www.facebook.com/"></form-field>
      </div>
      <hr>
      <span class="lbl-deal-title mt-4">Cores e Aparência</span>
      <!-- <label-title class="mt-3" title="Cores" icon=""></label-title> -->
      <div class="row">
        <form-field v-model="configloja.cores.bg_buttons" type="color" col="3" label="Fundo dos Botões" name="bg_buttons"
          :v-errors="errors" v-validate="{}"></form-field>
        <form-field v-model="configloja.cores.fc_buttons" type="color" col="3" label="Fonte dos Botões" name="fc_buttons"
          :v-errors="errors" v-validate="{}"></form-field>
      </div>
      <div class="row">
        <form-field v-model="configloja.cores.bg_descontos" type="color" col="3" label="Fundo dos Descontos"
          name="bg_descontos" :v-errors="errors" v-validate="{}"></form-field>
        <form-field v-model="configloja.cores.fc_descontos" type="color" col="3" label="Fonte dos Descontos"
          name="fc_descontos" :v-errors="errors" v-validate="{}"></form-field>
      </div>
      <div class="row">
        <form-field v-model="configloja.cores.bg_promocao" type="color" col="3" label="Fundo Promoções" name="bg_promocao"
          :v-errors="errors" v-validate="{}"></form-field>
        <form-field v-model="configloja.cores.fc_promocao" type="color" col="3" label="Fonte Promoções" name="fc_promocao"
          :v-errors="errors" v-validate="{}"></form-field>
      </div>
      <div class="row">
        <form-field v-model="configloja.cores.bg_destaques" type="color" col="3" label="Fundo Destaques"
          name="bg_destaques" :v-errors="errors" v-validate="{}"></form-field>
        <form-field v-model="configloja.cores.fc_destaques" type="color" col="3" label="Fonte Destaques"
          name="fc_destaques" :v-errors="errors" v-validate="{}"></form-field>
      </div>
      <div class="row">
        <div class="col-12">
          <input-checkbox label="Adicionar bordar laterais na loja?" v-model="configloja.bordas_laterais_add"
            :value-checked="true" :value-unchecked="false"></input-checkbox>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <input-checkbox label="Exibir categoria ao iniciar loja" v-model="configloja.categoria_iniciar_aberta"
            :value-checked="true" :value-unchecked="false"></input-checkbox>
        </div>
      </div>
      <hr>
      <span class="lbl-deal-title mt-4">Rodapé</span>
      <!-- <label-title class="mt-3" title="Telefones para contato" icon=""></label-title> -->
      <div class="row">
        <form-field v-model="configloja.rodape.atendimento_obs" type="memo" col="6" label="Observação Atendimento"
          name="atendimento_obs" :v-errors="errors"></form-field>
      </div>
      <hr>
      <span class="lbl-deal-title mt-4">Páginas</span>
      <div class="row py-2">
        <div class="col-md-12 mb-3">
          <span class="lbl-edit">Configure aqui suas páginas adicionais sobre a sua empresa, políticas de troca, formas de
            pagamento, entre outros assuntos importantes.</span>
        </div>
        <div class="col-md-12 mb-3">
          <v-button label="Nova Página" :nb-btdef="true" @click="handleNewPagina"></v-button>
        </div>
        <div class="col-md-12 d-flex align-items-center ml-n2" v-for="(pagina, i) in configloja.paginas" :key="i">
          <form-field v-model="pagina.titulo" type="text" label="Título da Página" col="5" :disabled="true"></form-field>
          <form-field v-model="pagina.titulorodape" type="text" label="Título para Rodapé" col="3"
            :disabled="true"></form-field>
          <i class="fa" :class="pagina.ativa ? 'fa-check text-success mr-2' : 'fa-ban text-danger mr-2'"></i>
          <button class="btn btn-secondary" title="Configurar Página" @click="handleEditPagina(i)"><i
              class="fa fa-cog"></i></button>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-12">
          <v-button label="Salvar" :success="true" @click="handleSaveFilial"></v-button>
        </div>
      </div>
    </div>

    <!-- MODAL ADICIONAR PÁGINAS -->
    <div class="nb-modal-scrollable" v-if="showModalPaginas">
      <div class="container nb-modal-scrollable-container nb-email-container">
        <div class="nb-modal-header">
          <h5>Nova Pagina</h5>
          <button type="button" class="close" @click="closeModalPaginas" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="nb-modal-scrollable-body">
          <div class="container">
            <div class="row">
              <form-field v-model="pagina.titulo" type="text" label="Título" col="12"></form-field>
            </div>
            <div class="row">
              <form-field v-model="pagina.titulorodape" type="text" label="Título para Rodapé" col="12"></form-field>
            </div>
            <div class="row">
              <div class="col-md-12">
                <wysiwyg v-model="pagina.html" />
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12">
                <input-checkbox v-model="pagina.ativa" label="Ativa" :value-checked="true"
                  :value-unchecked="false"></input-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="nb-modal-scrollable-footer mt-4">
          <v-button ref="btnConfirm" label="Salvar" title="" :nb-btdef="true"
            @click="handleSavePagina(pagina)"></v-button>
          <v-button ref="btnClose" label="Cancelar" title="" @click="closeForm"></v-button>
        </div>
      </div>
    </div>


    <!-- BANNERS -->
    <div class="border p-3" v-if="tabBanner">
      <div class="">
        <span class="lbl-deal-title">Banners</span>
      </div>
      <!-- <label-title class="mb-2" title="Banners" icon=""> </label-title> -->
      <div class="row">
        <div class="col-12">
          <span class="lbl"> <strong>
              Adicione banners para apresentação na sua loja virtual </strong>
          </span>
          <span class="lbl-list">
            Efetue o upload de imagens e chame atenção do seu cliente para ofertas e condições comerciais.
          </span>
          <span class="lbl-list">
            É recomendado que a largura tenha entre 1200px a 1600px para tablets e desktops e 720px para celulares. Não é
            permitido imagens com mais de 2mb.
          </span>
        </div>
      </div>

      <div class="row mt-3" v-if="configloja">
        <div class="col-12 text-center d-flex justify-content-center" style="gap:15px">

          <span class="badge badge-yellow ml-1 px-2 my-auto">
            <i class="fa fa-desktop"></i>
            Imagens para Desktop
          </span>
          <v-button label="Imagem Para Desktop" icon="fa-upload" @click="handleClickAdicionaImagem('desktop')"></v-button>
        </div>
      </div>

      <div class="row mt-2" v-for="(banner, index) in configloja.banners_desktop" :key="index">
        <div class="col-auto m-auto">
          <v-button icon="fa-trash" @click="apiDeleteBanner(configloja.banners_desktop, index)"></v-button>
        </div>

        <div class="col-md-10 col-10 p-2 m-auto">
          <div class="card">
            <div class="card-img-top p-3">
              <div class="position-relative text-center">
                <img v-if="banner.url" style="max-width: 100%" :src="banner.url">
                <span v-else style="font-size: 250px"><i class="fa d-inline fa-camera"></i></span>
              </div>
            </div>
            <!-- <div class="card-body">
                        </div> -->
          </div>
        </div>
      </div>

      <div class="row mt-5" v-if="configloja">
        <div class="col-12 text-center px-2 d-flex justify-content-center" style="gap:15px">

          <span class="badge badge-yellow ml-2 my-auto">
            <i class="fa fa-mobile" style="font-size: 18px"></i>
            Imagens para Celular
          </span>
          <v-button label="Imagem Para Celular" icon="fa-upload" @click="handleClickAdicionaImagem('mobile')"></v-button>
        </div>
      </div>
      <div>

      </div>
      <div class="row mt-2" v-for="(banner, index) in configloja.banners_mobile" :key="index">
        <div class="col-auto m-auto">
          <v-button icon="fa-trash" @click="apiDeleteBanner(configloja.banners_mobile, index)"></v-button>
        </div>
        <div class="col-md-10 col-10 p-2 m-auto">
          <div class="card">
            <div class="card-img-top p-3">
              <div class="position-relative text-center">
                <img v-if="banner.url" style="max-width: 100%" :src="banner.url">
                <span v-else style="font-size: 250px"><i class="fa d-inline fa-camera"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="uploading">
        <div class="col-md-12">
          <div class="text-center p-3">
            <div class="imagem-galeria-loading">
              <div class="spinner-border text-muted"></div>
            </div>
          </div>
        </div>
      </div>



    </div>


    <!-- LOCAL DE RETIRADA E FORMAS DE ENVIO -->
    <div class="border p-3">
      <retirada-form v-if="tabFormasEnvio" :obj="configloja" @saveconfig="handleSaveFilial" />
      <!-- <correios-form v-if="tabFormasEnvio" :obj="configloja" @saveconfig="handleSaveFilial"></correios-form> -->
      <melhorenvio-form v-if="tabFormasEnvio" :obj="configloja" @saveconfig="handleSaveFilial" />
      <selformasenvio-form v-if="tabFormasEnvio" :parametros="configloja" @saveconfig="handleSaveFilial" />
      <formasenvio-list v-if="tabFormasEnvio" :obj="configloja" @saveconfig="handleSaveFilial" />


      <!-- PAGAMENTO ONLINE E FORMAS DE PAGAMENTO -->
      <pagonline-form v-if="tabPagamentos" :parametros="parametros" @saveconfig="handleSaveFilial" />
      <hr v-if="tabPagamentos">
      <bandeiras-form v-if="tabPagamentos" :parametros="configloja" @saveconfig="handleSaveFilial" />
      <hr v-if="tabPagamentos">
      <formaspagamento-list v-if="tabPagamentos" :obj="configloja" @saveconfig="handleSaveFilial" />
      <hr v-if="tabPagamentos">
      <analisefraude-form v-if="tabAnaliseFraude" :parametros="configloja" @saveconfig="handleSaveFilial" />

      <input v-show="false" type="file" ref="file" accept="image/*" @change="handleUploadBanner($event)">
      <!-- CONFIGURAÇÃO DE EMAIL -->
      <config-mail-loja v-if="tabConfigMail" :parametros="configloja" @editMode="handleEditMail($event)"
        @insertMode="handleInsertMail($event)" @deleteMode="handleDelete($event)" />
      <div class="row mt-5" v-if="tabConfigMail">
        <div class="col-12">
          <v-button label="Salvar" :success="true" @click="handleSaveFilial"></v-button>
        </div>
      </div>
    </div>


    <!-- ANALISE DE FRAUDE -->
  </div>
</template>

<script>

import { SysVars } from '../main'
import axios from 'axios'
import { apiORDSpost, apiORDSmidia } from '../shared/api-functions'
import FormasenvioList from './config-formasenvio-list-loja'
import FormaspagamentoList from './config-formaspagamento-list-loja'
import RetiradaForm from './config-retirada-form-loja'
import CorreiosForm from './config-correios-form-loja'
import MelhorenvioForm from './config-melhorenvio-form-loja'
import PagonlineForm from './config-pagonline-form-loja'
import BandeirasForm from './config-bandeiras-form-loja'
import AnalisefraudeForm from './config-analisefraude-form-loja'
import SelformasenvioForm from './config-selformasenvio-form-loja'
import ConfigMailLoja from './config-mail-loja.vue'
export default {
  props: {
    codfil: '',
  },

  components: {
    FormasenvioList, ConfigMailLoja, FormaspagamentoList, PagonlineForm, RetiradaForm, AnalisefraudeForm, CorreiosForm, BandeirasForm, SelformasenvioForm, MelhorenvioForm
  },

  data() {
    return {
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela

      uploadingBanner: null,
      uploadingImage: null,
      uploading: false,
      selectedFile: null,
      showPagOnline: false,

      image: null,

      filial: {},

      configloja: {
        codtabpre: null,
        b2b: null,
        valor_minimo_pedido: null,
        controlaestoque: false,
        codusuario: null,
        whatsapp: null,
        facebook: null,
        instagram: null,
        fone: null,
        banners_desktop: [],
        banners_mobile: [],
        bordas_laterais_add: false,
        bordas_laterais: 0,
        categoria_iniciar_aberta: false,
        cores: {
          bg_top_bottom: '#0340A6',
          fc_top_bottom: '#FFFFFF',
          bg_buttons: '#0340A6',
          fc_buttons: '#FFFFFF',
          bg_promocao: '',
          fc_promocao: '',
          bg_destaques: '',
          fc_destaques: '',
          bg_descontos: '',
          fc_descontos: '',
          bg_aviso_sacola: '',
          fc_aviso_sacola: '',
          bg_rodape: '',
          fc_rodape: '',
        },
        formasenvio: [],
        formaspagamento: [],
        tppedv: 'O',
      },

      retirada: {
        nome: null,
        endereco: null,
      },

      parametros: {
      },

      pagonlineObj: {
        habilitaCielo: false,
        habilitaRede: false,
        habilitaShopline: false,
        habilitaCieloCheckout: false,
        habilitaShoplineCheckout: false,
        habilitaRedeCheckout: false,
        habilitaPagseguro: false,
        habilitaPagseguroCheckout: false,
        cielo: {
          clientid: null,
          clientsecret: null,
          desconto: null,
          observacao: null,
        },
        shopline: {
          codigosite: null,
          chave: null,
          observacaoboleto: null,
          desconto: null,
          observacao: null,
        },
        rede: {
          token: null,
          pv: null,
          desconto: null,
          parcelas: 1,
          valorMinimoParcela: 0,
          observacao: null,
        },
        pixitau: {
          clientid: null,
          clientsecret: null,
          desconto: null,
          observacao: null,
        },
        pagseguro: {
          email: null,
          token: null,
          desconto: null,
          observacao: null,
        },
      },


      rodapeObj: {
        atendimento_obs: null,
        habilitaBandeiras: true,
        bandeiras: {
          boleto: true,
          visa: true,
          mcard: true,
          elo: true,
          american_express: true,
          dinners_club: true,
          hipercard: true,
          jcb: false,
          discover: false,
          aura: true,
        },
        habilitaFormasEnvio: true,
        formasenvio: {
          correios: true,
          pac: true,
          sedex: true,
          jadlog: true,
          latam: true,
          azul_express: true,
        },
      },

      analisefraudeObj: {
        habilitaClearsale: false,
        clearsale: {
          login: null,
          senha: null,
          token: null,
          fingerprint: null,
        },
      },

      correiosObj: {
        contrato: false,
        codempresa: null,
        senha: null,
        habilitasedex: true,
        habilitapac: true,
        codigopac: null,
        codigosedex: null,
        valoradicional: null,
        maopropria: false,
        valordeclarado: false,
        avisorecebimento: false,
      },

      melhorenvioObj: {
        clientid: null,
        clientsecret: null,
        maopropria: false,
        valordeclarado: false,
        avisorecebimento: false,
        valoradicional: null,
        prazoadicional: null,
      },

      activeTab: 0,

      tabs: [
        { title: 'Seus Dados', icon: 'fa-building' },
        { title: 'Parâmetros e Aparência', icon: 'fa-cog' },
        { title: 'Banners', icon: 'fa-window-maximize' },
        { title: 'Formas de Envio', icon: 'fa-truck' },
        { title: 'Formas de Pagamento', icon: 'fa-window-maximize' },
        { title: 'Análise de Fraude', icon: 'fa-window-maximize' },
        { title: 'Configuração de Email', icon: 'fa-envelope-o' }
      ],

      showModalPaginas: false,
      pagina: null
    }
  },

  computed: {
    tabpreList: function () {
      return this.$store.getters.getTabpreList
    },
    tabDados: function () {
      return this.activeTab == 0
    },
    tabConfig: function () {
      return this.activeTab == 1
    },
    tabBanner: function () {
      return this.activeTab == 2
    },
    tabFormasEnvio: function () {
      return this.activeTab == 3
    },
    tabPagamentos: function () {
      return this.activeTab == 4
    },
    tabAnaliseFraude: function () {
      return this.activeTab == 5
    },
    tabConfigMail: function () {
      return this.activeTab == 6
    }
  },

  watch: {

  },


  methods: {
    handleDelete(index) {
      this.configloja.emails.splice(index, 1)
    },
    handleInsertMail(mail) {
      this.configloja.emails.unshift(mail)
    },
    handleEditMail(obj) {
      console.log(obj)
      this.configloja.emails[obj.index] = obj.mail
    },
    closeForm() {
      this.$emit('closeform')
    },

    changeTab(idx) {
      this.activeTab = idx
    },

    handleSaveFilial() {

      if (this.parametros.pagonline.habilitaCieloCheckout || this.parametros.pagonline.habilitaRedeCheckout || this.parametros.pagonline.habilitaShoplineCheckout || this.parametros.pagonline.habilitaPagseguroCheckout) {
        this.configloja.tppedv = 'P';
      }

      if (this.configloja.bordas_laterais_add) {
        this.configloja.bordas_laterais = 10
      }

      //BOTAO SALVAR
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
        } else {
          this.apiPostFilial('put')
        }
      })
    },

    async loadData() {
      //carrega o registro para alteracao ou visualizacao
      await this.$store.dispatch('loadFilial', { id: this.codfil })
      if (this.$store.getters.getFilial) {
        this.filial = { ...this.$store.getters.getFilial }
        if (this.filial.parametros) {
          this.parametros = JSON.parse(this.filial.parametros)
        } else {
          this.parametros = {}
        }
        if (this.parametros.hasOwnProperty('pagonline') == false) {
          this.parametros.pagonline = this.pagonlineObj
        }
        if (this.parametros.pagonline.hasOwnProperty('rede') == false) {
          this.parametros.pagonline.rede = this.pagonlineObj.rede
        }

        if (this.parametros.pagonline.hasOwnProperty('pagseguro') == false) {
          this.parametros.pagonline.pagseguro = this.pagonlineObj.pagseguro;//{ email: 'notabrasil@htdsistemas.com.br', token: 'F11D8AECC8D144FF83592BFDF8A22D60' }
        }

        if (this.filial.parametrosloja) {
          this.configloja = JSON.parse(this.filial.parametrosloja)
        }

        if (this.configloja.hasOwnProperty('codempresa') == false) {
          this.configloja.codempresa = this.filial.codempresa
        }
        if (this.parametros.hasOwnProperty('codempresa') == false) {
          this.parametros.codempresa = this.filial.codempresa
        }

        if (this.configloja.hasOwnProperty('analisefraude') == false) {
          this.configloja.analisefraude = this.analisefraudeObj
        }
        if (this.configloja.analisefraude.hasOwnProperty('clearsale') == false) {
          this.configloja.analisefraude.clearsale = this.analisefraudeObj.clearsale
        }
        if (this.configloja.analisefraude.clearsale.hasOwnProperty('fingerprint') == false) {
          this.configloja.analisefraude.clearsale.fingerprint = null
        }
        if (!this.configloja.correios) {
          this.configloja.correios = this.correiosObj
        }
        if (!this.configloja.melhorenvio) {
          this.configloja.melhorenvio = this.melhorenvioObj
        }
        if (this.configloja.hasOwnProperty('rodape') == false) {
          this.configloja.rodape = this.rodapeObj
        }
        if (this.configloja.rodape.hasOwnProperty('bandeiras') == false) {
          this.configloja.rodape.habilitaBandeiras = true
          this.configloja.rodape.bandeiras = this.rodapeObj.bandeiras
        }
        if (this.configloja.rodape.hasOwnProperty('formasenvio') == false) {
          this.configloja.rodape.habilitaFormasEnvio = true
          this.configloja.rodape.formasenvio = this.rodapeObj.formasenvio
        }
        if (this.configloja.rodape.hasOwnProperty('atendimento_obs') == false) {
          this.configloja.rodape.atendimento_obs = null
        }
        if (this.configloja.hasOwnProperty('bordas_laterais_add') == false) {
          this.configloja.bordas_laterais_add = false
          this.configloja.bordas_laterais = 0
        }
        if (this.configloja.hasOwnProperty('bordas_laterais') == false) {
          this.configloja.bordas_laterais = 0
        }
        if (this.configloja.hasOwnProperty('categoria_iniciar_aberta') == false) {
          this.configloja.categoria_iniciar_aberta = false
        }
        if (this.configloja.hasOwnProperty('paginas') == false) {
          this.configloja.paginas = [
            { titulo: 'Sobre a Loja/Quem Somos', tituloRodape: null, html: null, ativa: false, },
            { titulo: 'Politica de Trocas e Devoluções', tituloRodape: null, html: null, ativa: false, },
            { titulo: 'Como Comprar', tituloRodape: null, html: null, ativa: false, },
            { titulo: 'Perguntas Frequentes', tituloRodape: null, html: null, ativa: false, },
          ]
        }
        if (this.configloja.hasOwnProperty('emails') == false) {
          this.configloja.emails = [
            { id: null, assunto: null, tipo: null, corpo: null }
          ]
        }
        if (this.configloja.hasOwnProperty('b2b') == false) {
          this.configloja.b2b = false
        }
        if (this.configloja.hasOwnProperty('valor_minimo_pedido') == false) {
          this.configloja.valor_minimo_pedido = null
        }




      } else {
        // INCLUI UMA FILIAL
        this.filial = { ...this.$store.getters.getEntities.filial }
        this.filial.nome = this.$store.getters.getSessao.empresa_nome
        this.filial.fantasia = this.$store.getters.getSessao.empresa_nome
        this.filial.cnpj = this.$store.getters.getSessao.cnpj
        await this.apiPostFilial('post')
        this.loadData()
        return
      }

      this.loadLogotipo()

      if (!this.configloja.controlaestoque)
        this.configloja.controlaestoque = false
      if (!this.configloja.formaspagamento)
        this.configloja.formaspagamento = []
      if (!this.configloja.formasenvio)
        this.configloja.formasenvio = []
      if (!this.configloja.habilitaRetirada) {
        this.configloja.habilitaRetirada = false
        this.configloja.retirada = this.retirada
      }
      if (!this.configloja.rodape) {
        this.configloja.rodape = this.rodapeObj
      }
      if (!this.configloja.rodape.bandeiras) {
        this.configloja.rodape.habilitaBandeiras = true
        this.configloja.rodape.bandeiras = this.rodapeObj.bandeiras
      }
      if (!this.configloja.rodape.formasenvio) {
        this.configloja.rodape.habilitaFormasEnvio = true
        this.configloja.rodape.formasenvio = this.rodapeObj.formasenvio
      }
      if (!this.configloja.rodape.atendimento_obs) {
        this.configloja.rodape.atendimento_obs = null
      }
      if (!this.configloja.bordas_laterais_add) {
        this.configloja.bordas_laterais_add = false
        this.configloja.bordas_laterais = 0
      }
      if (!this.configloja.bordas_laterais) {
        this.configloja.bordas_laterais = 0
      }
      if (!this.configloja.categoria_iniciar_aberta) {
        this.configloja.categoria_iniciar_aberta = false
      }

      if (this.parametros.pagonline.hasOwnProperty('cielo')) {
        if (this.parametros.pagonline.cielo.hasOwnProperty('desconto') == false) {
          this.parametros.pagonline.cielo.desconto = null
        }
        if (this.parametros.pagonline.cielo.hasOwnProperty('observacao') == false) {
          this.parametros.pagonline.cielo.observacao = null
        }
      }

      if (this.parametros.pagonline.hasOwnProperty('rede')) {
        if (this.parametros.pagonline.rede.hasOwnProperty('desconto') == false) {
          this.parametros.pagonline.rede.desconto = null
        }
        if (this.parametros.pagonline.rede.hasOwnProperty('observacao') == false) {
          this.parametros.pagonline.rede.observacao = null
        }
      }

      if (this.parametros.pagonline.hasOwnProperty('shopline')) {
        if (this.parametros.pagonline.shopline.hasOwnProperty('desconto') == false) {
          this.parametros.pagonline.shopline.desconto = null
        }
        if (this.parametros.pagonline.shopline.hasOwnProperty('observacao') == false) {
          this.parametros.pagonline.shopline.observacao = null
        }
      }

      if (this.parametros.pagonline.hasOwnProperty('pixitau')) {
        if (this.parametros.pagonline.pixitau.hasOwnProperty('desconto') == false) {
          this.parametros.pagonline.pixitau.desconto = null
        }
        if (this.parametros.pagonline.pixitau.hasOwnProperty('observacao') == false) {
          this.parametros.pagonline.pixitau.observacao = null
        }
      }

      if (this.parametros.pagonline.hasOwnProperty('pagseguro')) {
        if (this.parametros.pagonline.pagseguro.hasOwnProperty('desconto') == false) {
          this.parametros.pagonline.pagseguro.desconto = null
        }
        if (this.parametros.pagonline.pagseguro.hasOwnProperty('observacao') == false) {
          this.parametros.pagonline.pagseguro.observacao = null
        }
      }


      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })
    },

    async apiPostFilial(metodo) {
      //efetua a gravacao
      this.filial.parametros = this.parametros
      this.filial.parametrosloja = this.configloja
      var sendData = { filial: this.filial }

      var modulo = 'cg/filial/'
      const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
      if (data.errmessages) {
        this.errmessages = data.errmessages
        this.$erpToastError('Alguns erros precisam ser corrigidos.')
      } else {
        this.$erpToastUpdated()
        this.errmessages = {}
        console.log(this.configloja)
        SysVars.loja_b2b = this.configloja.b2b == true
      }
    },

    handleClickAdicionaImagem(tipo) {
      let obj = {
        image: null,
        tipo: tipo,
        url: null,
        coddoc: null,
      }
      this.uploadingImage = obj
      this.$refs.file.value = ''
      this.$refs.file.click()
    },

    handleUploadBanner(event) {
      if (event.target.files[0]['type'] !== 'image/jpeg' && event.target.files[0]['type'] !== 'image/png') {
        this.$erpToastError('Arquivo não permitido')
        return
      }
      this.selectedFile = this.$refs.file.files[0]
      // image: URL.createObjectURL(this.selectedFile),
      this.uploading = true
      this.apiUploadBanner(this.selectedFile, this.callBackUpload)
    },

    callBackUpload(data, error) {
      this.uploading = false
      if (data) {
        this.uploadingImage.url = data.url
        this.uploadingImage.coddoc = data.coddoc
        if (this.uploadingImage.tipo == 'desktop')
          this.configloja.banners_desktop.push(this.uploadingImage)
        else
          this.configloja.banners_mobile.push(this.uploadingImage)
        this.apiPostFilial('put')
        this.$erpToastSuccess('Documento atualizado')
      }
      if (error) {
        this.$erpToastError('erro: ' + error)
      }
    },


    apiUploadBanner(selectedFile, callBack) {
      let formData = new FormData();
      formData.append('file', selectedFile);

      let url = this.$store.getters.urlOrds + 'docs/'
      let self = this
      let ref = 'bannerloja'

      axios.post(url, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'ref': ref,
            'chaveref': null,
            'filename': selectedFile.name
          }
        }
      ).then(function (response) {
        if (response.data.items) {
          if (callBack)
            callBack(response.data.items[0])
        }
      })

    },


    apiDeleteBanner(imagens, index) {
      //REMOVE A IMAGEM E ATUALIZA A CONFIGURACAO DA LOJA
      var url = this.$store.getters.urlOrds + 'docs/' + imagens[index].coddoc
      var self = this
      axios.delete(url).then(function (data) {
        imagens.splice(index, 1)
        //ATUALIZA A CONFIGURACAO DA LOJA
        self.apiPostFilial('put')
        self.$erpToastSuccess('O arquivo foi removido')
      })
    },



    loadLogotipo() {
      apiORDSmidia(this.$store.getters.urlApp + 'logo/download/' + this.filial.codempresa + '/' + this.filial.codfil).then(
        data => {
          if (data && data.size > 0) {
            let self = this
            let reader = new window.FileReader();
            reader.readAsDataURL(data);
            reader.onload = function () {
              self.image = reader.result;
            }
          }
        }

      )
    },

    handleClickLogotipo(cod) {
      this.$refs.logotipo.value = ''
      this.$refs.logotipo.click()
    },

    handleUploadLogotipo(event) {
      this.selectedFile = event.target.files[0]
      // this.urlImage = URL.createObjectURL(this.selectedFile)
      this.uploadLogotipo()
    },

    uploadLogotipo() {
      //EFETUA O UPLOAD DO LOGOTIPO

      let formData = new FormData();
      formData.append('file', this.selectedFile);

      var url = this.$store.getters.urlApp + 'logo/'

      var self = this

      axios.post(url, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'codfilial': this.filial.codfil,
            'filename': this.selectedFile.name
          }
        }
      ).then(function (data) {
        self.$erpToastSuccess('O logotipo foi atualizado com sucesso.')
        self.loadLogotipo()
      })

    },

    updateCep() {
      //CARREGA INFORMACOES DO CEP
      this.filial.ende = SysVars.endereco.logradouro
      this.filial.bairro = SysVars.endereco.bairro
      this.filial.codmun = SysVars.endereco.ibge
      this.filial.uf = SysVars.endereco.uf
    },

    handleNewPagina() {
      this.pagina = { titulo: '', html: '', ativa: false }
      this.showModalPagina()
    },

    handleSavePagina(pagina) {
      const index = this.configloja.paginas.indexOf(pagina)

      if (this.configloja.paginas.includes(pagina)) {
        this.configloja.paginas[index] = pagina
      } else {
        this.configloja.paginas.unshift(pagina)
      }

      this.closeModalPaginas()
    },

    handleEditPagina(index) {
      this.pagina = this.configloja.paginas[index]
      this.showModalPagina()
    },

    showModalPagina() {
      this.showModalPaginas = true
    },

    closeModalPaginas() {
      this.pagina = null
      this.showModalPaginas = false
    }

  },

  beforeCreate() {

  },

  mounted() {
    this.$nextTick(function () {
      // this.$refs.nome.focus()
    })
  },

  created() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })

    this.loadData()

  }

}

</script>

<style>
.nb-modal-scrollable-container {
  top: 0;
  /* height: 100%; */
  border: none;
}

.spacing-my {
  margin: 1.5rem 0;
}

.spacing-py {
  padding: 1rem 0;
}

.spacing-px {
  padding: 0 1rem;
}</style>



// WEBPACK FOOTER //
// src/forms-loja/config-form-loja.vue